














































































import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import Title from '@/components/Title';
import SearchingPanel from '@/components/SearchingPanel';
import InformationCard from '@/components/InformationCard';
import BannerWithSlot from '@/components/BannerWithSlot';
import VLazyImage from 'v-lazy-image';
import {mapActions, mapGetters} from 'vuex';
import {isIOS} from 'mobile-device-detect';
import {objectToQuerystring} from '@/services/api';

@Component({
  name: 'AboutServices',
  components: {
    BannerWithSlot, InformationCard,
    SearchingPanel, Title, VLazyImage,
  },
  data() {
    return {
      actualQuery: {},
      ios: isIOS,
    };
  },
  computed: {
    ...mapGetters([
      'searchingPanel',
      'chooseButtonLink',
      'actualSearchData',
      'mobAppLinks',
    ]),
    ...mapGetters('about', [
      'aboutDesignTexts',
      'aboutServicesTexts',
    ]),
  },
  methods: {
    ...mapActions(['updateActualSearchData']),

    sendToApiSearch(data) {
      this.$set(this, 'actualQuery', {...this.actualQuery, ...data});
      this.updateActualSearchData(this.actualQuery);
      this.$router.push({path: `/catalog/?${objectToQuerystring(this.actualQuery)}`});
    },

    srcImg(photo) {
      return photo && `${photo[3600]}` || '';
    },

    srcImgPlaceholder(photo) {
      return photo && `${photo[400]}`;
    },

    srcSet(photo) {
      return photo && `${photo[400]} 400w, ${photo[400]} 800w,
      ${photo[400]} 1300w, ${photo[800]} 1900w, ${photo[3600]} 3600w`;
    },
  },
})
export default class AboutServices extends Vue {
}
